import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormRhombus: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-rhombus"><path d="M5.25 12L12 2.25L18.75 12L12 21.75L5.25 12Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormRhombus;
